var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticStyle:{"font-size":"15px"},attrs:{"transition":"fade-transition"}},'v-icon',attrs,false),on),[_vm._v(" mdi-help-circle ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.ToolMessage))])])}
var staticRenderFns = []

export { render, staticRenderFns }